import MainSwiper from "../mainSwiper";
import { MainSectionWrapper } from "./styles";

export default function MainSection() {
  return (
    <MainSectionWrapper>
      {/* <MainCarousel /> */}
      <MainSwiper />
    </MainSectionWrapper>
  );
}
